import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./contextApi/Auth_context";

export default function Protected({ children }) {
  const { user } = useAuth();

  if (!sessionStorage.getItem("user")||sessionStorage.getItem("user")=="undefined" ) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
